import { useTranslations } from "@zapier/i18n";
import { useState, useEffect } from "react";
import { Key, Select, SelectItem } from "@zapier/design-system";
import { useAccountActionPermissions } from "@zapier/client";
import { Icon } from "@zapier/zinnia-icons";
import { useRouterParams } from "@zapier/shared";
import styles from "./TemplatesSharingFilter.module.css";

export function TemplatesSharingFilter() {
  const t = useTranslations("templates-sharing-filter");

  const { shared, setParams } = useRouterParams();
  const [selected, setSelected] = useState<string>("all");
  const { isSharingEnabled } = useAccountActionPermissions();

  useEffect(() => {
    setSelected(shared || "all");
  }, [shared]);

  const onValueChange = (value: Key | null) => {
    const finalValue = (value as string) || "all";
    setSelected(finalValue);

    const omit: string[] = [];
    if (finalValue === "me") {
      omit.push("owner");
    }

    setParams({ shared: finalValue, page: 1 }, omit);
  };

  return (
    <div className={styles.root}>
      <Select
        label={t("labels.filter-templates")}
        isLabelHidden={true}
        placeholder={t("labels.select")}
        onChange={onValueChange}
        selectedKey={selected}
        size="medium"
      >
        <SelectItem value="all" textValue="All templates">
          {t("options.all-templates")}
        </SelectItem>
        <SelectItem value="me" textValue="Owned by me">
          {t("options.owned-by-me")}
        </SelectItem>
        <SelectItem value="-me" textValue="Shared with me">
          <span className={styles.shared}>
            {t("options.shared-with-me")}
            {!isSharingEnabled && (
              <Icon
                color="GrayWarm6"
                size="20"
                name="actionLock"
                aria-label={t("options.shared-with-me-disabled")}
              />
            )}
          </span>
        </SelectItem>
      </Select>
    </div>
  );
}
